const jobs = {
  update: {
    summary: {
      supplier: 'Flota',
      notRouted: 'Não Distribuído',
    },
  },
  forms: {
    information: {
      supplier: {
        header: 'Flota',
      },
    },
  },
  table: {
    actions: {
      route: 'Distribuir',
    },
    statuses: {
      new: 'Não Distribuído',
      routed: 'Distribuído',
    },
    cells: {
      supplier: {
        none: 'Sem Flotas',
      },
    },
    filters: {
      supplier: 'Flotas',
    },
    headers: {
      supplier: 'Flotas',
    },
  },
};

export default jobs;
